import { useEffect, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { useEditor, findSection } from "@/components/editor/useEditorState";
import CostButton from "./CostButton";
import ProposalCard from "./ProposalCard";
import SharedLock from "./SharedLock";
import TextPicker from "./TextPicker";
import { useAiEdits } from "./useAiEdits";

const TYPES = [["text", "Testo"], ["section", "Sezione"], ["page", "Pagina"]];
const HINT = { text: "Es. più breve e diretto, tono più caldo…", section: "Es. layout più arioso, card con prezzi in evidenza… (facoltativo)", page: "Es. più sezioni di fiducia, CTA più visibile… (facoltativo)" };

export default function RegenPanel() {
  const ed = useEditor();
  const { selection, content, pageId, ui, setUi } = ed;
  const hook = useAiEdits(["text", "section", "page"]);
  const [type, setType] = useState("section");
  const [text, setText] = useState(null);
  const [instruction, setInstruction] = useState("");
  const [unlock, setUnlock] = useState(false);
  useEffect(() => { if (ui.regenTarget) { setType(ui.regenTarget); setUi({ regenTarget: null }); } }, [ui.regenTarget]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (ed.picked?.text) setType("text"); }, [ed.picked]);
  useEffect(() => { setText(null); }, [selection?.id, type]);

  const sec = selection?.kind === "section" ? findSection(content, selection.id) : null;
  const comp = selection?.kind === "component" ? content.components.find((c) => c.id === selection.id) : null;
  const page = content.pages.find((p) => p.id === pageId);
  const target = sec ? { kind: "section", id: sec.section.id } : comp ? { kind: "component", id: comp.id } : ed.picked?.id ? { kind: ed.picked.kind, id: ed.picked.id } : null;
  const base = { instruction, unlock_shared: unlock };
  const body = type === "text" ? (text && target && { kind: "text", text: text.text, where: text.where, section_id: target.kind === "section" ? target.id : "", component_id: target.kind === "component" ? target.id : "", ...base })
    : type === "section" ? (sec && { kind: "section", section_id: sec.section.id, ...base })
      : page && { kind: "page", page_id: page.id, ...base };
  const what = type === "section" ? (sec ? `Sezione «${sec.section.name}» (${sec.page.name})` : "Seleziona una sezione nell'anteprima o dal pannello Sezioni")
    : type === "page" ? `Pagina «${page?.name}»: solo le sue sezioni, le altre pagine restano invariate` : "";
  return (
    <div className="p-3 space-y-4" data-testid="regen-panel">
      <div className="grid grid-cols-3 gap-1 rounded-lg bg-slate-100 p-0.5" data-testid="regen-type">
        {TYPES.map(([k, l]) => <button key={k} onClick={() => setType(k)} className={`rounded-md py-1.5 text-xs font-medium transition-colors ${type === k ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"}`} data-testid={`regen-type-${k}`}>{l}</button>)}
      </div>
      {what && <p className="text-[12px] text-slate-700" data-testid="regen-target">{what}</p>}
      {type === "text" && <TextPicker target={target} value={text} onChange={setText} />}
      <div className="space-y-1">
        <p className="text-[11px] text-slate-500">Come vuoi cambiarlo?</p>
        <Textarea rows={2} value={instruction} onChange={(e) => setInstruction(e.target.value)} placeholder={HINT[type]} className="text-sm resize-none" data-testid="regen-instruction" />
      </div>
      <SharedLock on={unlock} setOn={setUnlock} />
      <CostButton path="/ai-edits/estimate" body={body} label="Genera proposta" disabled={!body || !!hook.running} busy={hook.busy === "create"}
        onRun={(est) => hook.create(body, est)} testid="regen-run-btn" />
      <p className="text-[10.5px] text-slate-500">Vedrai prima le differenze e l'anteprima: nulla cambia finché non premi «Applica».</p>
      <div className="space-y-2" data-testid="regen-proposals">{hook.edits.slice(0, 6).map((e) => <ProposalCard key={e.id} e={e} hook={hook} />)}</div>
    </div>
  );
}
